import * as types from './types'
export default {
  [types.SET_DEVICES](state, data) {
    state.totalDevices = 0
    state.devices = []
    if (data !== undefined && data !== null) {
      console.log('Devices', data)
      if (data.length > 0) {
        state.totalDevices = data[0].TotalItems
        for (let item of data) {
          item.isChecked = false
        }
        state.devices = data
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/mutations.js